if (!customElements.get('countdown-component')) {
	class Countdown extends HTMLElement {
		constructor() {
			super();
			document.addEventListener('DOMContentLoaded', () => {
				this.countdownDate = new Date(this.dataset.countdown);
				this.init();
			});
		}

		init() {
			const countDownDate = this.countdownDate.getTime();

			// Update the count down every 1 second
			this.interval = setInterval(() => {
				// Get today's date and time
				const now = new Date().getTime();

				// Find the distance between now and the count down date
				const distance = countDownDate - now;

				// Time calculations for days, hours, minutes and seconds
				const days = Math.floor(distance / (1000 * 60 * 60 * 24));
				const hours = Math.floor(
					(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
				);
				const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
				const seconds = Math.floor((distance % (1000 * 60)) / 1000);

				// Display the result in the element with id="demo"
				this.innerHTML = `
					<span class="inline-flex gap-1 items-start">
						${this.component(days, "Days")}
						${this.component(hours, "Hrs")}
						${this.component(minutes, "Mins")}
						${this.component(seconds, "Secs", true)}
					</span>
				`;

				// If the count down is finished, write some text
				if (distance < 0) {
					clearInterval(this.interval);
					this.innerHTML = "now"; // TODO: What to do with empty
				}
			}, 1000);
		}

		component(time = 0, title = 'Secs', last = false) {
			const el = "clock-time";
			return `
				<span class="${el} block text-center [.d1_&]:min-w-[35px] [.d1_&]:lg:min-w-[74px]">
					<span class="${el}__number flex items-center justify-start text-center gap-1">
						${String(time).padStart(2, "0")}
					</span>
					<span class="${el}__title block text-base [.block-announcement_&]:text-[9px] -mt-1">${title}</span>
				</span>
				${!last ? '<span class="leading-none">:</span>' : ""}
			`;
		}
	}

	customElements.define('countdown-component', Countdown);
}
